import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[aceNumericOnly]'
})
export class NumericOnlyDirective {
  private navigationKeys = [
    'Backspace',
    'Delete',
    'Tab',
    'Escape',
    'Enter',
    'Home',
    'End',
    'ArrowLeft',
    'ArrowRight',
    'Clear',
    'Copy',
    'Paste'
  ];
  inputElement: HTMLInputElement;
  constructor(public el: ElementRef) {
    this.inputElement = el.nativeElement;
  }

  @HostListener('keydown', ['$event'])
  onKeyDown(e: KeyboardEvent) {
    let numDecimalCharacters: number = 0;
    let currentValue = this.inputElement.value;
    let i: number = 0;


    for (i = 0; i < currentValue.length; i++) {
      if(currentValue.charAt(i) === '.'){
        numDecimalCharacters++;
      }
    }

    if(numDecimalCharacters === 1 && e.keyCode === 190)
      e.preventDefault();
    
    if (
      this.navigationKeys.indexOf(e.key) > -1 || // Allow: navigation keys: backspace, delete, arrows etc.
      (e.key === 'a' && e.ctrlKey === true) || // Allow: Ctrl+A
      (e.key === 'c' && e.ctrlKey === true) || // Allow: Ctrl+C
      (e.key === 'v' && e.ctrlKey === true) || // Allow: Ctrl+V
      (e.key === 'x' && e.ctrlKey === true) || // Allow: Ctrl+X
      (e.key === 'a' && e.metaKey === true) || // Allow: Cmd+A (Mac)
      (e.key === 'c' && e.metaKey === true) || // Allow: Cmd+C (Mac)
      (e.key === 'v' && e.metaKey === true) || // Allow: Cmd+V (Mac)
      (e.key === 'x' && e.metaKey === true)// Allow: Cmd+X (Mac)
    ) {
      // let it happen, don't do anything
      return;
    }
    // Ensure that it is a number and stop the keypress
    if (
      (e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) &&
      (e.keyCode < 96 || e.keyCode > 105) 
    ) {
      e.preventDefault();
    }

    

  }

  @HostListener('keyup', ['$event'])
  onKeyUp(e: KeyboardEvent){
    let currentValue = this.inputElement.value;
    
    //trim last digit if more than two characters after decimal place
    let postDecimalChars: number = 0;
    let i: number = 0;
    let decimalCharLocated: boolean = false;

    for (i = 0; i < currentValue.length; i++) {

      if(decimalCharLocated)
      postDecimalChars++;
      
      if(decimalCharLocated === false)
        if(currentValue.charAt(i) === '.')
          decimalCharLocated = true;
    }

    if(postDecimalChars > 2){
      this.inputElement.value = currentValue.substring(0, currentValue.length - 1);
    }


  }

  @HostListener('paste', ['$event'])
  onPaste(event: ClipboardEvent) {
    event.preventDefault();
    var pastedInput: any = event.clipboardData?.getData('text/plain').replace(/\D/g, ''); // get a digit-only string
    document.execCommand('insertText', false, pastedInput);
  }

  @HostListener('drop', ['$event'])
  onDrop(event: DragEvent) {
    event.preventDefault();
    const textData = event.dataTransfer?.getData('text').replace(/\D/g, '');
    this.inputElement.focus();
    document.execCommand('insertText', false, textData);
  }


}
